import {process, users} from '@mep/pae-commons';

const {USER_TYPES} = users;
const {PROCESS_IDENTIFIERS} = process;

export const CACHE_KEY_LIST_EXPEDIENT = 'expedients';
export const CACHE_KEY_LIST_EXPEDIENT_BACK_MODAL = 'expedient-reason-back-dialog';
export const CACHE_KEY_EXPEDIENT = 'expedient-one';
export const ROUTE_PATH_EXPEDIENT = '/proposal-files/expedients';
export const TRANSLATION_PREFIX_EXPEDIENT = 'expedient';
export const SECURITY_KEY_EXPEDIENT = 'EXPEDIENT';

export const CACHE_KEY_LIST_PROCESSED_EXPEDIENT = 'processed-expedients';
export const CACHE_KEY_PROCESSED_EXPEDIENT = 'processed-expedient-one';
export const ROUTE_PATH_PROCESSED_EXPEDIENT = '/proposal-files/processed-expedients';
export const TRANSLATION_PREFIX_PROCESSED_EXPEDIENT = 'processed_expedient';

export const CACHE_KEY_LIST_MY_EXPEDIENTS = 'myExpedients';
export const TRANSLATION_PREFIX_MY_EXPEDIENTS_OWNER = 'myExpedients';
export const TRANSLATION_PREFIX_MY_EXPEDIENTS = 'proposalFiles';
export const ROUTE_USER_PATH_EXPEDIENTS = '/expedients';

export const DISMISS_MODAL_KEY = 'dismiss-expedient';

export const EXPEDIENT_PROCESS_ACCESS_USER_TYPES = {
  // Elaboración de la Escritura Notarial
  [PROCESS_IDENTIFIERS.MEP_REVISION]: [USER_TYPES.FUNCTIONARY],
  // Elaboración de la Escritura Notarial
  [PROCESS_IDENTIFIERS.NOTARY_REGISTER]: [USER_TYPES.FUNCTIONARY, USER_TYPES.NOTARY, USER_TYPES.NOTARY_DPJ],
  // Inscripción en el Registro Mercantil
  [PROCESS_IDENTIFIERS.COMMERCIAL_REGISTER]: [USER_TYPES.FUNCTIONARY, USER_TYPES.COMMERCIAL_REGISTER],
};

